import PageLayout from 'pages/ForgotPassword/PageLayout';
import PageProvider from 'pages/ForgotPassword/PageProvider';

const ForgotPasswordPage = (props) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default ForgotPasswordPage;
